import React from 'react';
import $ from 'jquery';

import './maps.scss';

export default class RegionMapBaseComponent extends React.Component {
  constructor(props) {
    super(props);
    this.initSelectedValues = this.initSelectedValues.bind(this);
  }

  initSelectedValues() {
    let locations = this.props.locations
    if (locations) {
      for (let i in locations) {
        if (locations.hasOwnProperty(i)) {
          let location = locations[i];
          let mapArea = $('map.region-map area[data-location~="' + location + '"]');
          let data = mapArea.data('maphilight') || {};
          data.alwaysOn = true;
          data.fillOpacity = 1.00;
          mapArea.data('maphilight', data);
        }
      }
    }
  }

  componentDidMount() {
    let self = this;
    this.initSelectedValues();
    this.initMap();
    $('map.region-map area.location').click(function (event) {
      event.preventDefault();
      let mapItem = $(this);
      let locationData = mapItem.attr('data-location').split(' ').map(function (loc) {
        return parseInt(loc, 10);
      });
      locationData.forEach(function (loc) {
        self.props.handleChange('locations', loc);
        if (self.props.locations.indexOf(loc) === -1) {
          mapItem.data('maphilight', { fillOpacity: 0, alwaysOn: false });
        } else {
          mapItem.data('maphilight', { fillOpacity: 1.00, alwaysOn: true });
        }
      });
      self.initMap();
    });
  }

  initMap() {
    let mapOptions = {
      fillColor: 'F2CA72',
      fillOpacity: 0.60,
      stroke: false,
      strokeOpacity: 0
    };
    $('.map').maphilight(mapOptions);
  }
}



// WEBPACK FOOTER //
// ./src/components/search/maps/region-map-base.jsx